import { enumChartTypes } from "../constants";
import { LineConnector } from "./LineConnector";
import { NodeEntity } from "./NodeEntity";
import { NodePoly } from "./NodePoly";
import { QLayoutExtras } from "./QLayoutExtras";
import { UnitTestPolys } from "../utils/UnitTestPolys";

export class QBranchMgr {
  constructor() {
    // declare instance variables
    this.fRootEntity = null;
    this.fLineConnector = null;
    this.fLayoutExtras = null;
    this.fPageWidth = 0;
    this.fChartType = enumChartTypes.standard;
    this.fUsesMgrGrouping = false;
  }

  InitBranchMgr(pageWidth) {
    // put any initialization that needs to happen once
    this.fPageWidth = pageWidth;
  }

  GetChartType() {
    // put any initialization that needs to happen once
    return this.fChartType;
  }

  CalculatePageLayout(rootNode, pageAuxLines, chartType) {
    this.fRootEntity = new NodeEntity();
    this.fLineConnector = new LineConnector();
    this.fLineConnector.SetInvertedChart(chartType === enumChartTypes.inverted);
    this.fLayoutExtras = new QLayoutExtras();
    this.fChartType = chartType;

    for (var i = 0; i < 2; i++) {
      this.fRootEntity.Initialize(rootNode, null, this);
      var needToReCalculate = this.fRootEntity.AssignCoordinates(true, this.fPageWidth);
      if (!needToReCalculate) break;
    }

    this.fRootEntity.UpdatePositions(chartType, true);
    this.fLineConnector.AddConnectingLines(this.fRootEntity);

    // When done repositioning all the nodes add the subordinate connecting lines
    this.fLayoutExtras.GenerateBoxGroups(this.fRootEntity);

    if (rootNode.IsInMainSubChart()) {
      this.fLayoutExtras.GenerateAuxAssociations(this.fRootEntity, pageAuxLines);
      this.fLayoutExtras.UpdateDottedLines(rootNode, pageAuxLines);
      this.fLayoutExtras.GenerateConnectedLine(this.fRootEntity, pageAuxLines, chartType);
    }
  }

  //=====================================================================================
  // Debugging code
  DetailNode(aNode) {
    var dbObj = aNode.GetDataObj();
    if (dbObj == null) return;

    console.log("====>Detail Node<====");

    var nodeID = aNode.GetID();
    console.log("Node ID>" + nodeID);

    var parentNode = aNode.GetParent();
    var parentID = -1;
    if (parentNode) parentID = parentNode.GetID();
    console.log("Parent Node ID>" + parentID);

    var dbID = dbObj.GetObjectID();
    console.log("DBObj ID>" + dbID);

    var branchStyle = aNode.GetBranchStyle();
    console.log("Branch Style>" + branchStyle);

    var r = aNode.GetBaseRect();
    console.log(
      "Boundary Rect> Left:" +
        r.fLeft +
        " Top:" +
        r.fTop +
        " Right:" +
        r.fRight +
        " Bottom:" +
        r.fBottom
    );

    var m = aNode.GetBoxMargins();
    console.log(
      "Margin Rect> Left:" +
        m.fLeft +
        " Top:" +
        m.fTop +
        " Right:" +
        m.fRight +
        " Bottom:" +
        m.fBottom
    );

    var v1 = aNode.GetMgrVSpacing1();
    console.log("Mgr Spacing Below> " + v1);
    var v2 = aNode.GetMgrVSpacing2();
    console.log("Mgr Spacing Above> " + v2);

    var s1 = aNode.GetBoxSpacing();
    console.log(
      "Box Spacing> Left:" +
        s1.fLeft +
        " Top:" +
        s1.fTop +
        " Right:" +
        s1.fRight +
        " Bottom:" +
        s1.fBottom
    );

    console.log("====>End Detail Node<====");
  }

  // This is where the magic goes...
  DetailCalls(rootNode) {
    // Get the number of children for the root node
    var n = rootNode.GetNumChildren();
    this.DetailNode(rootNode);

    for (var i = 0; i < n; i++) {
      var child = rootNode.GetIndexChild(i);
      var m = child.GetNumChildren();
      console.log("Child Node has " + m + " children.");
      this.DetailNode(child);
    }
  }

  //=====================================================================================
  Tests() {
    UnitTestPolys.Test1();
    UnitTestPolys.Test2();
    UnitTestPolys.Test3();
    UnitTestPolys.Test4();
    UnitTestPolys.Test5();
    UnitTestPolys.Test6();
    UnitTestPolys.Test7();
    UnitTestPolys.Test8();
  }

  TestHDistance() {
    var box = { left: 0, right: 100, top: 0, bottom: 20 };
    var poly1 = new NodePoly();
    var poly2 = new NodePoly();
    poly1.InitNodePolyFromBox(box);
    poly2.InitNodePolyFromBox(box);

    var hDistance = poly1.HorizontalDistance(poly2);
  }
}
